import { Station } from '@app/core/types/stations';
import { usePntAppControllerGetLowerthirdByDate } from '@mi-front/api-v2';
import { parseRangeFromTs } from '@mi-front/core';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../stores/stream-screen.store';
import LowerthirdView from './LowerthirdView';
import { normalizeLowerthirdByDateResponse } from './normalize-lowerthird-by-date-response';

interface ILowerthirdContainer {
  station: Station;
}

const LowerthirdContainer: React.FunctionComponent<ILowerthirdContainer> = (props) => {
  const { station } = props;
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const range = parseRangeFromTs(debouncedFocus);
  const { data, isLoading } = usePntAppControllerGetLowerthirdByDate(station.slug, {
    from: range.from,
    to: range.to,
  });

  return (
    <LowerthirdView
      data={normalizeLowerthirdByDateResponse(data)}
      loading={isLoading}
      station={station}
    />
  );
};

export default LowerthirdContainer;
